import { SocketData } from 'actions/socket/socketReceiveDataAction'

import { fixBackendMessage } from './fixBackendMessage'
import {
  ChatMessengerState,
  MessageFromCometContent,
} from '../ChatMessengerState'

/**
 * Входящее обновления инфы о чате:
 * https://youtrack.mamba.ru/issue/M-9430#focus=Comments-4-58067.0-0
 *
 * Т.к. в канале mamba.messenger.message.${userId} такой информации нет.
 * @param chatState
 * @param incomingMessage
 * @returns
 */
export const updateChatData = (
  chatState: ChatMessengerState,
  incomingMessage: SocketData<MessageFromCometContent>
): ChatMessengerState => {
  /** Обновляем данные только открытого чата */
  if (
    incomingMessage.content.contact.lastMessage?.user_from_id ===
    chatState.selectedProfileId
  ) {
    fixBackendMessage(incomingMessage.content)

    return {
      ...chatState,

      chatData: {
        ...chatState.chatData,
        ...incomingMessage.content.contact,
        anketa: {
          ...chatState.chatData.anketa!,
          ...incomingMessage.content.contact.anketa,
        },
      },
    }
  }

  console.warn('Last user chat update skipped', incomingMessage)

  return chatState
}
